module.exports = __webpack_public_path__ + "static/media/IMG_0180.6d1e287e.jpg";